import { InterestRate } from "@justhome/api-core";
import { Period } from "./types";

export const colorsRGB = {
  cadet: "5 114 187",
  marigold: "184 127 13",
  mindaro: "101 140 15",
} as const;

export const lines: {
  id: keyof InterestRate;
  label: string;
  color: keyof typeof colorsRGB;
}[] = [
  {
    id: "tenYearInterestRate",
    label: "10 Jahre",
    color: "marigold",
  },
  {
    id: "fifteenYearInterestRate",
    label: "15 Jahre",
    color: "cadet",
  },
  {
    id: "twentyYearInterestRate",
    label: "20 Jahre",
    color: "mindaro",
  },
];

export const periods: { id: Period; label: string }[] = [
  {
    id: "6m",
    label: "6 Monate",
  },
  {
    id: "12m",
    label: "1 Jahr",
  },
  {
    id: "60m",
    label: "5 Jahre",
  },
  {
    id: "120m",
    label: "10 Jahre",
  },
  {
    id: "180m",
    label: "15 Jahre",
  },
];
